import { create as createApi } from 'apisauce';
import uuidv4 from 'uuid/v4';
import config from '../config';
import { actions as authActions } from '../actions/authActions';
import { actions as budgetAuthActions }  from '../actions/budgetAuthActions';

let syncedStore = { dispatch: () => { } };

export const syncApiWithStore = (store) => {
  syncedStore = store;
};

class BlobApiBase {
  static create() {
    const api = createApi({
      baseURL: config.API_URL,
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json'
      },
      timeout: 1000000,
      withCredentials: true,
      responseType: 'blob',
    });

    api.addMonitor(response => {
      if (response.status === 401 || response.status === 403) {
        if (response.config.url.startsWith('/budget')) {
          syncedStore.dispatch(budgetAuthActions.signOut());  
        } else {
          syncedStore.dispatch(authActions.signOut());
        }
      }
    });

    api.addRequestTransform(request => {
      request.headers['X-Correlation-ID'] = uuidv4();
    });

    return api;
  }
}

export default BlobApiBase.create();



// WEBPACK FOOTER //
// ./src/api/blobApiBase.js